import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import Spinner from '../../../components/Widgets/spinner';
import SpinnerButton from '../../Common/SpinnerButton';
import CashFormatter from '../../Common/cashFormatter';
import ReceivingDetailTable from './ReceivingDetailTable';

import { fetchReceiveHistoryByPO } from '../../../actions/purchaseOrderList_actions';

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const propTypes = {
  rowKey: PropTypes.string,
  poNum: PropTypes.number,
  poId: PropTypes.number,
  warehouse: PropTypes.object,
};

const defaultProps = {
  rowKey: 'Index',
  poNum: undefined,
  poId: undefined,
  warehouse: undefined,
};

class ReceivingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      receiveHistoryLine: {
        rows: [],
        selectedRows: null,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      isLoadingImages: false,
      receivingDetailOpen: false,
    };
  }

  componentDidMount() {
    this.fetchReceiveHistory();
  }

  fetchReceiveHistory = () => {
    const handleSuccess = (response) => {
      // Invoices, TotalBalance, TotalCount, TotalFinalPrice
      const rows = response.data.Invoices || [];
      rows.map((row, index) => {
        row.Index = index;
      });
      const receiveHistoryLine = {
        ...this.state.receiveHistoryLine,
        rows,
      };
      
      this.setState({
        receiveHistoryLine,
        isLoadingImages: false,
      });
    };
    const handleFailure = (error) => {
      alert(error);
      const receiveHistoryLine = {
        ...this.state.receiveHistoryLine,
        rows,
      };
      this.setState({
        receiveHistoryLine,
        isLoadingImages: false,
      });
    };
    this.setState({
      isLoadingImages: true,
    }, () => fetchReceiveHistoryByPO(this.props.poNum, this.props.warehouse, handleSuccess, handleFailure));
  }

  renderTable() {
    const getRows = () => Data.Selectors.getRows(this.state.receiveHistoryLine);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };
    
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const columns = [
      {
        key: 'PONum',
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }, {
        key: 'WarehouseReceiveNum',
        name: <Translate value="receive_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      }, {
        key: 'WarehouseName',
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: 'InvoiceNum',
        name: <Translate value="invoice_vendor" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: 'VendorName',
        name: <Translate value="vendor" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      }, {
        key: 'PurchaseFinalPrice',
        name: <Translate value="po_final_dollarsign" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: CashFormatter,
      }, {
        key: 'FinalPrice',
        name: <Translate value="receive_final_dollarsign" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: CashFormatter,
      }, {
        key: 'InvoiceFinalPrice',
        name: <Translate value="invoice_final_dollarsign" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: CashFormatter,
      }, {
        key: 'InvoiceStatus',
        name: <Translate value="invoice_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: ({ value }) => (
          <div>
            <Translate value={ value } />
          </div>
        ),
      }, {
        key: 'ArrivalStatus',
        name: <Translate value="arrival_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: ({ value }) => (
          <div>
            <Translate value={ value } />
          </div>
        ),
      }, {
        key: 'PaymentStatus',
        name: <Translate value="payment_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: 'PostingDate',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
        width: 90,
      }, {
        key: 'Create_Username',
        name: <Translate value="created_by" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }, {
        key: 'Modify_Username',
        name: <Translate value="modify" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }, {
        key: 'container_num',
        name: <Translate value="container_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      }, {
        key: 'Owner',
        name: <Translate value="owner" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: 'Note',
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: "100%" }} id="Category_2-dataGrid1">
            <DraggableContainer>
              <ReactDataGrid
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                rowHeight={25}
                headerRowHeight={45}
              />
            </DraggableContainer>
          </div>
        </Col>
      </Row>
    );
  }
  
  openReceiveDetail() {
    this.setState({ receivingDetailOpen: true });
  }
  closeReceiveDetail() {
    this.setState({ receivingDetailOpen: false });
  }

  render() {
    const modalStyle = {
      width: '1012px',
      height: '500px',
    };
    return (
      <ContentWrapper>
        <div id="product-images-modal">
          <div>
            <div className="toolbar-row">
              <ButtonToolbar>
                <Button
                  bsStyle="warning"
                  type="button"
                  onClick={() => { this.openReceiveDetail() }}
                >
                  <em className="fa fa-pencil" /><Translate value="edit" />
                </Button>
              </ButtonToolbar>
            </div>
            {this.renderTable()}
          </div>
        </div>
        <SkyLightStateless
          dialogStyles={modalStyle}
          isVisible={this.state.receivingDetailOpen}
          onCloseClicked={() => { this.closeReceiveDetail(); }}
          title={<Translate value="edit_receiving" />}
        >
          <ReceivingDetailTable
            poId={this.props.poId}
            handleClosed={() => { this.closeReceiveDetail(); }}
            handleRefetch={() => { this.fetchReceiveHistory(); }}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

ReceivingTable.propTypes = propTypes;
ReceivingTable.defaultProps = defaultProps;

export default ReceivingTable;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/components/ReceivingTable.jsx